module.exports = __webpack_public_path__ + "public/images/program/program-1.374b85bc64dfbafaeccf28fe09491869.png";